// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AuthenticationType;
(function (AuthenticationType) {
    AuthenticationType[AuthenticationType["Velocity"] = 8] = "Velocity";
    AuthenticationType[AuthenticationType["CapitalFutures"] = 11] = "CapitalFutures";
})(AuthenticationType || (AuthenticationType = {}));
